import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  color,
} from 'vibeguide';
import './OrderStatItem.scss';

function OrderStatItem({
  className,
  style,
  title,
  value,
  currency,
}) {
  const localeValue = (value) => {
    if (currency) {
      return value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });
    }

    return value.toLocaleString();
  };

  return (
    <div
      className={classNames('OrderStatItem', className)}
      style={style}
    >
      <div
        style={{
          marginBottom: 12,
          color: color.manatee,
        }}
      >
        {title}
      </div>

      <div
        style={{
          fontSize: 30,
        }}
      >
        {localeValue(value)}
      </div>
    </div>
  );
}

OrderStatItem.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  currency: PropTypes.bool,
};

OrderStatItem.defaultProps = {
  className: '',
  style: {},
  currency: false,
};

export default OrderStatItem;
